import { render } from "./DashboardSales.vue?vue&type=template&id=4d1409f8"
import script from "./DashboardSales.vue?vue&type=script&lang=js"
export * from "./DashboardSales.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__